module.exports = __webpack_public_path__ + "static/media/w.5533da81.png";